module.exports = __webpack_public_path__ + "static/wishtel-bfc8e18d72ece0ee66caddd62a76f344.png";